module.exports = __webpack_public_path__ + "img/move.b1b587ab.png";